const Random = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
export function DecideIfBonus() {
    const result = Random(1, 10) 
    const isBonus =  result === 1;
    return isBonus ? 10 : undefined;
}